import SessionManager from "../../utils/authHandling/session-manager";

export const logoutUser = () => {
  SessionManager.deleteSession();
  window.location.href = "./#/login";
  window.location.reload();
}